import type { SVGProps } from 'react';
import {
  CalendarIcon,
  CompassIcon,
  FileTextIcon,
  HomeIcon,
  MessageSquareIcon,
} from '@/shared/icons';
import { CreditCardIcon } from '@/features/payments/components/PaymentIcons';
import { APP_PATHS } from '@/app/routes/paths';

export type PrimaryNavIcon = (props: SVGProps<SVGSVGElement>) => JSX.Element;

export interface PrimaryNavItem {
  readonly label: string;
  readonly path: string;
  readonly Icon: PrimaryNavIcon;
}

export interface SidebarNavItem {
  readonly label: string;
  readonly path: string | null;
  readonly Icon: PrimaryNavIcon;
}

/** Main app destinations (mobile bottom bar). */
export const PRIMARY_NAV_ITEMS: readonly PrimaryNavItem[] = [
  { label: 'Home', path: APP_PATHS.feed, Icon: HomeIcon },
  { label: 'Messages', path: APP_PATHS.messages, Icon: MessageSquareIcon },
  { label: 'Calendar', path: APP_PATHS.calendar, Icon: CalendarIcon },
] as const;

/** Sidebar main nav — primary routes plus Explore. */
export const SIDEBAR_NAV_ITEMS: readonly SidebarNavItem[] = [
  { label: 'Home', path: APP_PATHS.feed, Icon: HomeIcon },
  { label: 'Explore', path: APP_PATHS.explore, Icon: CompassIcon },
  { label: 'Messages', path: APP_PATHS.messages, Icon: MessageSquareIcon },
  { label: 'Calendar', path: APP_PATHS.calendar, Icon: CalendarIcon },
] as const;

export const PAYMENTS_SIDEBAR_ITEM: SidebarNavItem = {
  label: 'Payments',
  path: APP_PATHS.payments,
  Icon: CreditCardIcon,
};

export const REPORT_CARDS_SIDEBAR_ITEM: SidebarNavItem = {
  label: 'Report Cards',
  path: APP_PATHS.reportCards,
  Icon: FileTextIcon,
};

/** Sidebar items with optional Payments and Report Cards inserted after Calendar. */
export function getSidebarNavItems(
  showPaymentsMenu: boolean,
  showReportCardsMenu: boolean,
): readonly SidebarNavItem[] {
  const items: SidebarNavItem[] = [];

  for (const item of SIDEBAR_NAV_ITEMS) {
    items.push(item);
    if (item.path === APP_PATHS.calendar) {
      if (showPaymentsMenu) {
        items.push(PAYMENTS_SIDEBAR_ITEM);
      }
      if (showReportCardsMenu) {
        items.push(REPORT_CARDS_SIDEBAR_ITEM);
      }
    }
  }

  return items;
}
